import { Amplify, Auth, Cache } from 'aws-amplify';
import { FEDERATED_APP_CLIENT_ID, FEDERATED_OAUTH } from "./common/CacheKeys";
import getOidcServiceInstance from "./eid/EIDOidcSingletonService";

export async function getAccessToken() {
    const oidcInstance = await getOidcServiceInstance();
    const eidUser = await oidcInstance?.getUser();
    if (eidUser && eidUser.access_token) {
        return eidUser.access_token;
    } else {
        return (await Auth.currentSession()).accessToken.jwtToken;
    }
}

export async function getAuthorization() {
    return `Bearer ${await getAccessToken()}`;
}

export function setupAmplify() {
    let federatedAppClient = Cache.getItem(FEDERATED_APP_CLIENT_ID);
    let oauth = Cache.getItem(FEDERATED_OAUTH);
    Amplify.configure({
        Auth: {
            region: window.__RUNTIME_CONFIG__.COGNITO_REGION,
            userPoolId: window.__RUNTIME_CONFIG__.COGNITO_POOL_ID,
            userPoolWebClientId: (federatedAppClient ? federatedAppClient : window.__RUNTIME_CONFIG__.COGNITO_CLIENT_ID),
            authenticationFlowType: 'USER_PASSWORD_AUTH',
            oauth: (oauth ? oauth : {})
        },
        Analytics: {
            disabled: true
        },
        API: {
            endpoints: [
                {
                    name: "Core",
                    endpoint: window.__RUNTIME_CONFIG__.API_HOST,
                    custom_header: async () => {
                        return { Authorization: await getAuthorization() }
                    }
                },
                {
                    name: "Unauthorized",
                    endpoint: window.__RUNTIME_CONFIG__.API_HOST
                }
            ]
        }
    })
}